// Apply parallax effect
function applyParallax() {
    // Adjust these values or add some to control the parallax intensity for different classes
    const speedMap = {
        'parallax-slowest': 0.075, // Slowest speed
        'parallax-slow': 0.15     // Slow speed
    };

    // Get viewport height for dynamic adjustment
    const viewportHeight = window.innerHeight;

    // Get all elements with parallax classes
    const parallaxElements = document.querySelectorAll('.parallax-slow, .parallax-slowest');

    function parallaxEffect() {
        // Calculate the scroll position
        const scrollPosition = window.scrollY;

        // Loop through each parallax element
        parallaxElements.forEach(element => {
            // Determine the parallax speed based on class
            const classList = Array.from(element.classList);
            const speedClass = classList.find(cls => speedMap[cls]);
            const speed = speedMap[speedClass] || 0;

            // Calculate the new position using viewport height for responsiveness
            const yOffset = scrollPosition * speed * (viewportHeight / 1000) * -1;

            // Apply the transform for parallax effect
            element.style.setProperty('--tw-translate-y', `${yOffset}px`);
        });

        // Request the next animation frame
        requestAnimationFrame(parallaxEffect);
    }

    // Initialize parallax effect
    parallaxEffect();
}

// Initialize parallax on page load and resize
applyParallax();
window.addEventListener('resize', applyParallax);
